export default "__VITE_ASSET__2058f98f__"